import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React from 'react';
import scrollIntoView from 'scroll-into-view';
import { window } from '../../../helpers/BrowserHelpers';
import { getHeaderDOMElementFromId } from '../../../utils/getHeaderDOMElement';
export default function BlockLinkScroller(_ref) {
  var editor = _ref.editor,
      blockId = _ref.blockId;

  var _React$useState = React.useState({
    highlight: false
  }),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      highlight = _React$useState2[0].highlight,
      setState = _React$useState2[1];

  React.useLayoutEffect(function () {
    var timeout;
    var scrollElement = getHeaderDOMElementFromId(editor, blockId);
    if (!scrollElement) return;
    scrollIntoView(scrollElement, {
      align: {
        top: 0,
        topOffset: 50
      }
    }, function (type) {
      if (type !== 'complete') return;
      setState({
        highlight: true
      });
      timeout = setTimeout(function () {
        window.location.hash = '';
        setState({
          highlight: false
        });
      }, 1500);
    });
    return function () {
      return clearTimeout(timeout);
    };
  }, [editor, blockId]);
  return React.createElement("style", {
    dangerouslySetInnerHTML: {
      __html: "\n          [data-slate-editor]>[data-scroll-id=\"".concat(blockId, "\"] {\n            transition: background-color 0.5s ease;\n            background-color: transparent;\n          }\n\n          ").concat(highlight ? "[data-slate-editor]>[data-scroll-id=\"".concat(blockId, "\"] {\n            border-radius: 1.5px;\n            background-color: rgba(100,224,143, 0.25);\n          }") : '', "\n      ")
    }
  });
}